/**
 * 支持以下坐标系：
 * 1. 经纬度
 * 2. 偏移经纬度，用于解决高精度抖动问题
 * 3. 瓦片坐标，用于数据瓦片
 * 4. 常规世界坐标系，用于常规 2D/3D 可视化场景
 * 5. P20
 * @see https://yuque.antfin-inc.com/yuqi.pyq/fgetpa/doml91
 */
// TODO：自动注入 Shader 中
export var CoordinateSystem; // 后续传入 Shader 的变量

(function (CoordinateSystem) {
  CoordinateSystem[CoordinateSystem["LNGLAT"] = 1] = "LNGLAT";
  CoordinateSystem[CoordinateSystem["LNGLAT_OFFSET"] = 2] = "LNGLAT_OFFSET";
  CoordinateSystem[CoordinateSystem["VECTOR_TILE"] = 3] = "VECTOR_TILE";
  CoordinateSystem[CoordinateSystem["IDENTITY"] = 4] = "IDENTITY";
  CoordinateSystem[CoordinateSystem["P20"] = 5] = "P20";
  CoordinateSystem[CoordinateSystem["P20_OFFSET"] = 6] = "P20_OFFSET";
  CoordinateSystem[CoordinateSystem["METER_OFFSET"] = 7] = "METER_OFFSET";
  CoordinateSystem[CoordinateSystem["P20_2"] = 8] = "P20_2";
})(CoordinateSystem || (CoordinateSystem = {}));

export var CoordinateUniform = {
  CoordinateSystem: 'u_CoordinateSystem',
  ViewportCenter: 'u_ViewportCenter',
  ViewportCenterProjection: 'u_ViewportCenterProjection',
  PixelsPerDegree: 'u_PixelsPerDegree',
  PixelsPerDegree2: 'u_PixelsPerDegree2',
  PixelsPerMeter: 'u_PixelsPerMeter',
  Mvp: 'u_Mvp'
};